module.exports = __webpack_public_path__ + "img/KORE.ad9c541a.svg";